<template>
  <v-app class="bg-grey-lighten-3">
    <slot />
  </v-app>
</template>

<style>
.v-messages__message {
  text-align: left !important;
  margin-bottom: 1em !important;
}
</style>
